import axios from 'axios';
import { API_BASE_URL } from './api';
import { auth, AUTH_MODE } from './firebase';

// Set default baseURL so all axios requests resolve against the backend
// when API_BASE_URL is set (cross-origin Cloud Run deployment).
if (API_BASE_URL) {
  axios.defaults.baseURL = API_BASE_URL;
}

if (AUTH_MODE === 'firebase') {
  // Request interceptor: attach Firebase ID token
  // Wrapped in try/catch so that a stale/missing token never blocks a request.
  axios.interceptors.request.use(async (config) => {
    try {
      const currentUser = auth?.currentUser;
      if (currentUser) {
        const token = await currentUser.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (authErr) {
      // Auth token unavailable — proceed without Authorization header
      console.warn('axios interceptor: could not obtain Firebase token', authErr?.message);
    }
    return config;
  });

  // Response interceptor: handle 401 by triggering re-auth
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        window.dispatchEvent(new Event('auth:unauthorized'));
      }
      return Promise.reject(error);
    }
  );
}
